import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import { attachDocsActions, documentUtils } from '@codametrix/ui-common';
import { logoutApp, login } from '../actions/login.action';
import { onLocationChange, logout } from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';

const resetModal = (state: typeof InitialState.attachDocs) => ({
  ...state,
  isOpen: false,
  loadingNotes: false,
  activeNotes: [],
  documentsAvailable: []
});

export const reducer = createReducer(InitialState.attachDocs, builder => {
  builder.addCase(logout.type, () => ({ ...InitialState.attachDocs }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.attachDocs }));

  builder.addCase(attachDocsActions.showAttachDocsModal, (state, action) => ({
    ...state,
    isOpen: true,
    currentCaseRun: action.payload,
    loadingNotes: false,
    activeNotes: [],
    documentsAvailable: []
  }));

  builder.addCase(attachDocsActions.fetchAvailableDocs.pending, state => ({
    ...state,
    loadingDocuments: true,
    documentsAvailable: []
  }));

  builder.addCase(attachDocsActions.fetchAvailableDocs.rejected, state => ({
    ...state,
    loadingDocuments: false,
    documentsAvailable: []
  }));

  builder.addCase(attachDocsActions.fetchAvailableDocs.fulfilled, (state, action) => ({
    ...state,
    loadingDocuments: false,
    documentsAvailable: action.payload
  }));

  builder.addCase(attachDocsActions.hideAttachDocsModal, resetModal);
  builder.addCase('AUTH_LOGOUT/pending', resetModal);
  builder.addCase('LOGIN/pending', resetModal);
  builder.addCase(onLocationChange.type, resetModal);

  builder.addCase(attachDocsActions.fetchSpecialtiesDictionary.fulfilled, (state, action) => ({
    ...state,
    specialtiesDictionary: action.payload
  }));

  builder.addCase(attachDocsActions.fetchNoteTypeDictionary.fulfilled, (state, action) => ({
    ...state,
    noteTypesDictionary: action.payload
  }));

  builder.addCase(attachDocsActions.downloadDocs.pending, state => ({
    ...state,
    loadingNotes: true
  }));

  builder.addCase(attachDocsActions.downloadDocs.rejected, state => ({
    ...state,
    loadingNotes: false
  }));

  builder.addCase(attachDocsActions.downloadDocs.fulfilled, (state, action) => {
    const downloadDocsResult = action.payload;
    const { doc } = downloadDocsResult;
    const { currentCaseRun } = state;

    return {
      ...state,
      loadingNotes: false,
      activeNotes: [
        ...downloadDocsResult.htmlNotes,
        ...downloadDocsResult.plainTextNotes
      ].map(noteContent => {
        const decoratedNote = documentUtils.decoratedNoteFactory({
          description:
            currentCaseRun?.description ?? doc?.documentDescription,
          content: noteContent,
          filename: currentCaseRun?.note_specialty_designation ?? 'Document',
          type: doc?.documentType,
          document_id: doc?.documentId,
          id: doc?.id,
          filetype: doc?.mimeType
        });

        return documentUtils.shimSegmentsIfNeeded(decoratedNote);
      })
    };
  });
});

export default reducer;
